// Банк по коду внутри казахстанского IBAN.
//
// IBAN РК — 20 знаков: KZ, две контрольные цифры, три цифры кода банка и 13
// знаков счёта. Код банка присваивает Нацбанк, при переименовании банка он не
// меняется (Сбербанк → Bereke, Цеснабанк → Jusan — коды прежние).
//
// Названия — как их пишут в договорах. Нет кода в списке — менеджер заполняет
// банк и БИК руками, как раньше.
export const KZ_BANKS = {
  601: { bic: 'HSBKKZKX', name: 'АО «Народный Банк Казахстана»' },
  722: { bic: 'CASPKZKA', name: 'АО «Kaspi Bank»' },
  856: { bic: 'KCJBKZKX', name: 'АО «Банк ЦентрКредит»' },
  470: { bic: 'IRTYKZKA', name: 'АО «ForteBank»' },
  435: { bic: 'SHBKKZKA', name: 'АО «Шинхан Банк Казахстан»' },
  949: { bic: 'ATYNKZKA', name: 'АО «Altyn Bank»' },
  551: { bic: 'KSNVKZKA', name: 'АО «Freedom Bank Kazakhstan»' },
  914: { bic: 'BRKEKZKA', name: 'АО «Bereke Bank»' },
  948: { bic: 'EURIKZKA', name: 'АО «Евразийский банк»' },
  826: { bic: 'TSESKZKA', name: 'АО «Jusan Bank»' },
  998: { bic: 'TSESKZKA', name: 'АО «Jusan Bank»' },
  886: { bic: 'INLMKZKA', name: 'АО «Home Credit Bank»' },
  849: { bic: 'NURSKZKX', name: 'АО «Нурбанк»' },
  821: { bic: 'KINCKZKA', name: 'АО «Bank RBK»' },
  972: { bic: 'HCSKKZKA', name: 'АО «Отбасы банк»' },
  563: { bic: 'KPSTKZKA', name: 'АО «Казпочта»' },
  432: { bic: 'VTBAKZKZ', name: 'ДО АО Банк ВТБ (Казахстан)' },
  832: { bic: 'CITIKZKA', name: 'АО «Ситибанк Казахстан»' },
  930: { bic: 'ICBKKZKX', name: 'АО «Торгово-промышленный Банк Китая в г. Алматы»' },
  885: { bic: 'KZIBKZKA', name: 'АО «ДБ «Казахстан-Зираат Интернешнл Банк»' },
  947: { bic: 'ALFAKZKA', name: 'АО «ДБ «Альфа-Банк»' },
  246: { bic: 'HLALKZKZ', name: 'АО «Исламский банк «Al Hilal»' },
  942: { bic: 'EXKAKZKA', name: 'АО «Эксимбанк Казахстан»' },
  907: { bic: 'DVKAKZKA', name: 'АО «Банк Развития Казахстана»' },
  125: { bic: 'NBRKKZKX', name: 'ГУ «Национальный Банк Республики Казахстан»' },
};

/** IBAN без пробелов, маски и в верхнем регистре. */
export const normalizeIban = (value) =>
  String(value ?? '').replace(/[\s_-]/g, '').toUpperCase();

/**
 * Контрольная сумма IBAN (ISO 13616, остаток 97 от перестановки первых четырёх
 * знаков в конец). Ловит опечатку в счёте до того, как платёж уйдёт в банк.
 */
export const isValidIban = (value) => {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const digits = rearranged.replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));

  // Число длиннее, чем влезает в double, поэтому делим по кусочкам.
  let remainder = 0;
  for (const digit of digits) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};

/** Банк и БИК по IBAN. Не казахстанский счёт или незнакомый код — null. */
export const bankByIban = (value) => {
  const iban = normalizeIban(value);
  if (!/^KZ\d{2}\d{3}/.test(iban)) return null;
  return KZ_BANKS[Number(iban.slice(4, 7))] || null;
};

export default KZ_BANKS;
